module.exports = __webpack_public_path__ + "static/media/sf-test-16.4ff61f72.mp3";